/**
 * Labstep
 *
 * @module components/Group/Form/ShowEdit/DefaultProtocolCollectionFolder
 * @desc Set the default_protocol_collection_folder for this group
 */

import { FormShowEditSearchSelect } from 'labstep-web/core/Form/ShowEdit/SearchSelect';
import { Folder } from 'labstep-web/models/folder.model';
import type React from 'react';
import type { GroupFormShowEditDefaultProtocolCollectionFolderProps } from './types';

export const GroupFormShowEditDefaultProtocolCollectionFolder: React.FC<
  GroupFormShowEditDefaultProtocolCollectionFolderProps
> = ({ group }) => (
  <FormShowEditSearchSelect
    placeholder={`Specify ${Folder.getHumanReadableEntityName(
      false,
      false,
    )}`}
    childEntityName={Folder.entityName}
    parentEntity={group}
    searchSelectProps={{
      params: { group_id: group.id, type: 'protocol_collection' },
      creatable: false,
      isClearable: true,
    }}
    childKeyName="default_protocol_collection_folder"
  >
    <div>
      {group.default_protocol_collection_folder
        ? group.default_protocol_collection_folder.name
        : 'No default protocol folder set'}
    </div>
  </FormShowEditSearchSelect>
);
